import { ModalId } from '@heidi/schema/ml-scribe';

/**
 * Seen-state id for the team-admin "Let your team start using Heidi II"
 * access-confirmation modal. The string is frozen — it keys `seen_modals`.
 */
export const HEIDI_2_CONFIRM_ACCESS_MODAL_ID =
  ModalId.T4_TEAM_ADMINS_HEIDI_2_CONFIRM_ACCESS_MODAL;
